import { Controller } from "@hotwired/stimulus"

// Legacy dialogs retain their own UI controllers. Managed dialogs own their cleanup.
export default class extends Controller {
  close() {
    this.element.querySelectorAll("dialog[open]:not([data-dialog-managed])")
      .forEach(dialog => dialog.close())
  }
}
